import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearStatusAnalyzeFile, setStatusAnalyzeFile } from './store/slices/uploadAndAnalyzeAI';
const RestoreStatus = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const savedStatus = localStorage.getItem('statusAnalyzeFile');
    if (savedStatus) {
      const parsedStatus = JSON.parse(savedStatus);
      dispatch(setStatusAnalyzeFile(parsedStatus));
    } else {
      dispatch(clearStatusAnalyzeFile());
    }
  }, [dispatch]);
  return null;
};
export default RestoreStatus;
